export enum ENV {
  ENDPOINT = 'ENDPOINT',
  LOCALES_SERVER_URL = 'LOCALES_SERVER_URL',
  SERVER_URL = 'SERVER_URL',
  STAGE = 'STAGE',
  FACEBOOK_ID = 'FACEBOOK_ID',
  GOOGLE_ID = 'GOOGLE_ID',
  NODE_ENV = 'NODE_ENV',
  PORT = 'PORT',
  AWS_DEFAULT_REGION = 'AWS_DEFAULT_REGION',
  AWS_ACCESS_KEY_ID = 'AWS_ACCESS_KEY_ID',
  AWS_SECRET_ACCESS_KEY = 'AWS_SECRET_ACCESS_KEY',
  AWS_ACCOUNT_ID = 'AWS_ACCOUNT_ID',
  DATADOG_ENABLED = 'DATADOG_ENABLED',
  VET_ADVICE_PROD_URL = 'VET_ADVICE_PROD_URL',
  VET_ADVICE_STAGING_URL = 'VET_ADVICE_STAGING_URL',
  VET_ADVICE_CRISP_PROD_ID = 'VET_ADVICE_CRISP_PROD_ID',
  VET_ADVICE_CRISP_STAGING_ID = 'VET_ADVICE_CRISP_STAGING_ID',
}

// eslint-disable-next-line @typescript-eslint/naming-convention
export enum WINDOW_ENV {
  ENDPOINT = 'ENDPOINT',
  LOCALES_SERVER_URL = 'LOCALES_SERVER_URL',
  SERVER_URL = 'SERVER_URL',
  STAGE = 'STAGE',
  FACEBOOK_ID = 'FACEBOOK_ID',
  GOOGLE_ID = 'GOOGLE_ID',
  NODE_ENV = 'NODE_ENV',
  PORT = 'PORT',
  DATADOG_ENABLED = 'DATADOG_ENABLED',
  VET_ADVICE_PROD_URL = 'VET_ADVICE_PROD_URL',
  VET_ADVICE_STAGING_URL = 'VET_ADVICE_STAGING_URL',
  VET_ADVICE_CRISP_PROD_ID = 'VET_ADVICE_CRISP_PROD_ID',
  VET_ADVICE_CRISP_STAGING_ID = 'VET_ADVICE_CRISP_STAGING_ID',
}
